module.exports = __webpack_public_path__ + "media/images/meta/logo-b624a2c2112b85cbc79cb472beb32da7.png";